import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button, Stack, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import ModalV2 from '/@/components/bayer/modal-v2';
import { _ } from '/@/locale';
import { mpTrackEvent } from '/@/store/tracking/mixpanel-events';
import { openWhatsappWeb } from '/@/utils';

export const getAgendVisitMessage = (growerName: string) => {
    return _(
        '“Hola {{growerName}}, ¿cómo estás? Te escribo porque me gustaría coordinar una recorrida de los lotes. ¿Cuándo tendrás disponibilidad?”',
        { growerName }
    );
};

export const agendVisit = (growerName: string, growerPhone?: string, growerId?: number) => {
    const message = getAgendVisitMessage(growerName);

    // Track WhatsApp message sent event
    if (growerId) {
        mpTrackEvent('Visit Scheduling Message Sent via WhatsApp', {
            grower_id: growerId,
        });
    }

    openWhatsappWeb({ message, phone: growerPhone });
};

const NextVisitModal = ({
    open,
    onClose,
    growerName,
    growerPhone,
    growerId,
}: {
    open: boolean;
    onClose: (e: React.MouseEvent<HTMLButtonElement>) => void;
    growerName: string;
    growerPhone?: string;
    growerId?: number;
}) => {
    const message = getAgendVisitMessage(growerName);
    return (
        <ModalV2
            open={open}
            onClose={onClose}
            title={_('Agendar una visita con el productor')}
            actionsProps={{
                justifyContent: 'flex-end',
                alignItems: 'center',
            }}
            actions={
                <>
                    <Button variant='text' color='secondary' onClick={onClose}>
                        {_('Cerrar')}
                    </Button>
                    <Button
                        variant='contained'
                        color='secondary'
                        onClick={(e) => {
                            agendVisit(growerName, growerPhone, growerId);
                            onClose(e);
                        }}
                    >
                        {_('Enviar por WhatsApp')}
                    </Button>
                </>
            }
        >
            <Stack
                className='mp-mask'
                spacing={2}
                sx={{
                    alignItems: 'left',
                    textAlign: 'left',
                }}
            >
                <Typography variant='subtitle1' color='primary'>
                    {_('Vas a enviarle un mensaje por WhatsApp para acordar el día de la visita.')}
                </Typography>
                <Stack
                    direction='column'
                    spacing={1}
                    p={1}
                    sx={{
                        background: '#E7F8FF',
                    }}
                >
                    <Typography variant='subtitle1' color='primary'>
                        {message}
                    </Typography>
                    <Stack direction='row' alignItems='center' justifyContent='end'>
                        <Button
                            variant='text'
                            color='primary'
                            startIcon={<ContentCopyIcon color='primary' />}
                            onClick={() => {
                                navigator.clipboard.writeText(message);
                                enqueueSnackbar(_('Mensaje copiado al portapapeles'), {
                                    variant: 'success',
                                });
                            }}
                        >
                            {_('Copiar mensaje')}
                        </Button>
                    </Stack>
                </Stack>
            </Stack>
        </ModalV2>
    );
};

export default NextVisitModal;
